export default __webpack_public_path__ + "static/media/tata.e0b64b3b.png";